import {
  PikkoloSDK,
  PikkoloEnvironment,
  PikkoloStationAndTime,
  EmailHash,
  PhoneNumberHash,
  PikkoloGetAvailableStationParams,
  PikkoloAvailableStations,
} from "./PikkoloSDK";

declare global {
  interface Window {
    pikkoloGetAvailableStations: (
      params: PikkoloGetAvailableStationParams
    ) => Promise<PikkoloAvailableStations>;
    pikkoloHashPhoneNumber: (phoneNumber: string) => PhoneNumberHash;
    pikkoloHashEmail: (email: string) => EmailHash;
    pikkoloShowChooseAnotherStationModal: () => Promise<
      PikkoloStationAndTime | undefined
    >;
  }
}

function setup() {
  let environment: PikkoloEnvironment = "staging";
  let vendorId = "-1";
  try {
    if (
      document &&
      document.currentScript &&
      document.currentScript instanceof HTMLScriptElement
    ) {
      const match = document.currentScript.src.match(/\?/);
      if (match) {
        const scriptUrl = match.index;
        let queryParametersString = document.currentScript.src.slice(scriptUrl);
        const queryParameters = new URLSearchParams(queryParametersString);

        environment =
          (queryParameters.get("environment") as PikkoloEnvironment) ||
          "staging";
        vendorId = queryParameters.get("vendorId") || "-1";
      } else {
        console.error(
          "[Pikkolo] Unable to parse query parameters - no query parameter founds"
        );
      }
    } else {
      console.error(
        "[Pikkolo] Unable to parse query parameters - no document or document.currentScript object"
      );
    }
  } catch (e) {
    console.error("[Pikkolo] Unable to parse query parameters", e);
  }

  let sdk = PikkoloSDK.make(environment, vendorId);

  window.pikkoloGetAvailableStations = (options) => {
    return sdk.getAvailableStations(options);
  };

  window.pikkoloHashPhoneNumber = (phoneNumber) => {
    return PikkoloSDK.hashPhoneNumber(phoneNumber);
  };

  window.pikkoloHashEmail = (email) => {
    return PikkoloSDK.hashEmail(email);
  };

  window.pikkoloShowChooseAnotherStationModal = () => {
    return sdk.showChooseAnotherStationModal();
  };
}

setup();
